import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';

import Intro from '../views/Intro.vue'
import Verification from '../views/Verification.vue'
import Results from '../views/Results.vue'
import TryAgain from '../views/TryAgain.vue'
import Confirmation from '../views/Confirmation.vue'

Vue.use(VueRouter)

const routes = [
  {
    path : "*",
    component: TryAgain
  },

  {
    path: '/',
    name: 'Intro',
    component: Intro
  },

  // {
  //   path: '/legal',
  //   name: 'Legal',
  //   component: Legal
  // },

  {
    path: '/results',
    name: 'Results',
    component: Results
  },

  {
    path: '/verify',
    name: 'Verification',
    component: Verification
  },

  {
    path: '/tryagain',
    name: 'TryAgain',
    component: TryAgain
  },

  {
    path: '/confirmation',
    name: 'Confirmation',
    component: Confirmation
  },


  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

/**/
router.beforeEach((to, from, next) => {
  // console.log('router: ', store, to, from , next);
  // console.log('router: ', store.getters.isValidSession);

  if(store.getters.isWinner === null){

    if( to.path !== '/tryagain' && to.path !== '/' ) {
      next('/');
    } else {
      next();
    }
    // next();

  } else {
    next();
  }


});
/**/


export default router
